/**
 * 关键词
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async saveFormDetail(params) {
    return request(api.answer.KEYWORDS, METHOD.POST, params);
  },
  async getFormDetail(keyId) {
    return request(api.answer.KEYWORDS + "/" + keyId, METHOD.GET);
  }
}

export default {dataApi}